import Vue from 'vue'
import { uuid } from 'vue-uuid'

import api from 'Api'
import URL_DEMO from 'Demo/collectors.json'

const URL = '/collector'
const URL_LOGS = '/status'

const isDemoMode = process.env.VUE_APP_MODE === 'demo'

const state = {
  collectors: [],
  loadingCollectors: true,
  buckets: [],
  bucketsLoading: false,
  _collectorLoadedItems: {
    collectors: {}
  }
}

const status = {
  collectorsLoading: false
}

const getters = {
  collectors: state => {
    return state.collectors
  },
  loadingCollectors: state => {
    return state.loadingCollectors
  },
  bucketsLoading: state => {
    return state.bucketsLoading
  },
  buckets: state => {
    return state.buckets
  },
  _collectorLoadedItems: state => {
    return state._collectorLoadedItems
  }
}

function get (context, URL, handler) {
  return api().get(URL).then(response => handler(context, response))
}

function post (context, URL, data, handler) {
  return api().post(URL, data).then(response => handler(context, response))
}

function put (context, data, handler) {
  return api().put(URL, data).then(response => handler(context, response))
}

function apiDelete (context, URL, id, handler) {
  return api().delete(URL + '/' + id).then(response => handler(context, id, response))
}

function handleCollectorLoad (context, response) {
  const collectors = response.data
  status.collectorsLoading = false
  if (collectors.error) {
    context.commit('apiError', collectors.error)
  } else {
    context.commit('collectorsLoaded', collectors)
    context.dispatch('getAllServers')
  }
  context.commit('setLoadingCollectors', false)
}

function handleBucketsLoaded (context, response) {
  const buckets = response.data
  if (buckets.error) {
    context.commit('apiError', buckets.error)
  } else {
    context.commit('bucketsLoaded', buckets)
  }
  context.commit('setBucketsLoading', false)
}

function handleCollectorSave (context, response) {
  const collector = response.data
  if (collector.error) {
    context.commit('apiError', collector.error)
  } else {
    context.commit('collectorSuccess', collector)
  }
}

function handleCollectorDelete (context, id, response) {
  const collector = response.data
  if (collector.error) {
    context.commit('apiError', collector.error)
  } else {
    context.commit('collectorDeleted', id)
  }
}

// function addIfPresent (source, destination, propertyName) {
//   if (source[propertyName]) {
//     destination[propertyName] = source[propertyName]
//   }
// }

function addOrUpdateCollector (collectors, collector) {
  collectors = collectors.map(item => item.entity_id !== collector.entity_id ? item : { ...item, ...collector })

  if (!collectors.find(item => item.entity_id === collector.entity_id)) {
    collectors.push(collector)
  }

  return collectors
}

function handlePollSave (context, response) {
  const poll = response.data
  if (poll.error) {
    context.commit('apiError', poll.error)
  } else {
    context.commit('pollSuccess', poll)
  }
}

const actions = {
  async loadCollectors (context, payload) {
    let data = []
    const organizationId = String(payload)
    context.commit('setLoadingCollectors', true)
    if (status.collectorsLoading && state._collectorLoadedItems.collectors[organizationId]) {
      return
    }
    if (payload) {
      status.collectorsLoading = true
      if (!isDemoMode) {
        try {
          data = await api().get(URL + '/organization/' + organizationId)
          handleCollectorLoad(context, data)
          state._collectorLoadedItems.collectors[organizationId] = true
          context.commit('setLoadingCollectors', false)
        } catch (error) {
          console.log(error)
        }
      } else {
        handleCollectorLoad(context, { data: URL_DEMO })
      }
    }
    return data
  },
  async loadBuckets (context, payload) {
    const collectorId = payload.collectorId
    if (context.state.bucketsLoading) {
      return
    }
    let data = []
    context.commit('setBucketsLoading', true)
    try {
      data = await api().get(URL + '/available-buckets?collector_id=' + collectorId)
      handleBucketsLoaded(context, data)
    } catch (error) {
      console.log(error)
    }
  },
  // getDemoCollectors (context, payload) {
  //   const collectors = get(context)
  // },
  saveCollector (context, payload) {
    const collectorData = {
      version: payload.version,
      entity_id: payload.entity_id,
      name: payload.name,
      collector_version: payload.collector_version,
      organization_id: payload.organization_id,
      drives: [],
      collector_type: payload.collector_type,
      environment_support: payload.environment_support,
      allowedScanTime: payload.allowedScanTime,
      allowedUploadTime: payload.allowedUploadTime,
      cluster_id: payload.cluster_id,
      cluster_status: payload.cluster_status,
      // 'status': payload['status'],
      configure_security: payload.configure_security ? payload.configure_security : null,
      drivesName: payload.drivesName ? payload.drivesName : {}
    }
    let req
    if (payload.entity_id) {
      req = put(context, collectorData, handleCollectorSave)
    } else {
      collectorData.entity_id = uuid.v4()
      req = post(context, URL, collectorData, handleCollectorSave)
    }
    // context.commit('updateCollectorData', collectorData);
    return req
  },
  savePoll (context, payload) {
    const pollData = {
      version: payload.version,
      id: payload.id,
      collector_version: payload.collector_version,
      polling_interval: payload.polling_interval
    }
    if (!payload.api_key) {
      Vue.notify({
        group: 'loggedIn',
        type: 'error',
        text: 'No any active API Key'
      })
      return
    }
    const axios = api()
    axios.defaults.headers.authorization = 'Bearer ' + payload.api_key // need to change header
    return axios.post('/poll', pollData).then(response => handlePollSave(context, response))
  },
  deleteCollector (context, id) {
    state.collectors = state.collectors.filter(collector => collector.entity_id !== id)
    return apiDelete(context, URL, id, handleCollectorDelete)
  },

  getCollectorLogs (context, payload) {
    return api().get(URL_LOGS + `?organization_id=${payload.organization_id}&collector_id=${payload.collector_id}&limit=15${payload.offset ? '&offset=' + payload.offset : ''}`)
  }

}

const mutations = {
  collectorsLoaded (state, collectors) {
    state.collectors = collectors
  },
  bucketsLoaded (state, buckets) {
    state.buckets = buckets
  },
  collectorSuccess (state, collector) {
    state.collectors = addOrUpdateCollector(state.collectors, collector)
    Vue.notify({
      group: 'loggedIn',
      type: 'success',
      text: 'Collector Saved'
    })
  },
  collectorDeleted (state, id) {
    Vue.notify({
      group: 'loggedIn',
      type: 'success',
      text: 'Collector deleted'
    })
  },
  updateCollectorData (state, collector) {
    state.collectors = addOrUpdateCollector(state.collectors, collector)
  },
  setLoadingCollectors (state, loading) {
    state.loadingCollectors = loading
  },
  setBucketsLoading (state, loading) {
    state.bucketsLoading = loading
  },
  pollSuccess (state, poll) {
    Vue.notify({
      group: 'loggedIn',
      type: 'success',
      text: 'Interval Saved'
    })
  },
  resetCollectors (state) {
    state.collectors = []
  }
}

export default {
  state,
  getters,
  actions,
  mutations,
  name: 'collectorStore'
}
